import type { RouteRecordRaw } from 'vue-router';
import { Permission } from '@shared';

const routes: RouteRecordRaw[] = [
  {
    name: 'products',
    path: '/products',
    component: () => import('../pages/ProductsPage.vue'),
    meta: {
      requiresAuth: true,
      permission: Permission.PRODUCT_LIST
    }
  }
];

export default routes;
